export interface ILocation {
  latitude: number;
  longitude: number;
}

export class LocationModel implements ILocation {
  latitude: number;
  longitude: number;

  private constructor(request: ILocation) {
    this.latitude = request.latitude;
    this.longitude = request.longitude;
  }

  static create(request?: ILocation) {
    return !!request ? new LocationModel(request) : LocationModel.createDefault();
  }

  static createDefault() {
    return new LocationModel({
      latitude: 24.88122384852,
      longitude: 46.660305165501
    });
  }
}
